import React from "react";

type ContextType = {
    type: string,
    team: string,
    match: string,
    setSession: (type: string, team: string, match: string) => void
    sessionId: () => string
}

export const Context = React.createContext<ContextType>({
    type: "",
    team: "",
    match: "",
    setSession: () => {},
    sessionId: () => ""
})

export function Provider ({children}: {children: React.ReactNode}) {
    const [type, setType] = React.useState<string>("");
    const [team, setTeam] = React.useState<string>("");
    const [match, setMatch] = React.useState<string>("");
    const setSession = (type: string, team: string, match: string) => {
        setType(type);
        setTeam(team);
        setMatch(match);
    }

    function sessionId() {
        return type + team + match;
    }

    return (
        <Context.Provider value={{
            type,
            team,
            match,
            setSession,
            sessionId
        }}>
            {children}
        </Context.Provider>
    )
}